export default "__VITE_PUBLIC_ASSET__68830d29__"